/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/send'
export default icon
